import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";

const HARVEST_PRODUCTS_API_URL = `${API_ROOT}/harvest-products`;

function getAuthHeaders(): { Authorization: string } {
  const authUser = getAuthUser();
  const token = authUser?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export interface HarvestProduct {
  id: string;
  name: string;
  quantity: number;
  price: number;
  discount: number | null;
  createdAt: string;
  updatedAt: string;
}

export async function callFetchHarvestProducts(): Promise<HarvestProduct[]> {
  const authUser = getAuthUser();
  const token = authUser?.token;
  if (!token) return [];
  const res = await axios.get<HarvestProduct[]>(HARVEST_PRODUCTS_API_URL, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(res.data) ? res.data : [];
}

export async function callCreateHarvestProduct(
  data: { name: string; quantity?: number; price?: number }
): Promise<HarvestProduct> {
  const res = await axios.post<HarvestProduct>(HARVEST_PRODUCTS_API_URL, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callUpdateHarvestProduct(
  id: string,
  data: { quantity: number; price: number; discount: number | null }
): Promise<HarvestProduct> {
  const res = await axios.put<HarvestProduct>(`${HARVEST_PRODUCTS_API_URL}/${id}`, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callDeleteHarvestProduct(id: string): Promise<void> {
  await axios.delete(`${HARVEST_PRODUCTS_API_URL}/${id}`, {
    headers: getAuthHeaders(),
  });
}
